document.addEventListener("DOMContentLoaded", () => {
  let header = document.getElementById("header-toolbar")
    ? document.getElementById("header-toolbar")
    : null;
  let stickyAtc = document.querySelector(".td-product-sticky-atc")
    ? document.querySelector(".td-product-sticky-atc")
    : null;
  let featuresContainer = document.querySelector(".product-features-container")
    ? document.querySelector(".product-features-container")
    : null;

  if (header && stickyAtc && featuresContainer) {
    document.addEventListener("scroll", function () {
      let headerBottom = header.getBoundingClientRect().bottom;
      let featuresContainerTop = featuresContainer.getBoundingClientRect().top;
      let speechBubble = document.getElementById("dummy-chat-button-iframe")
        ? document.getElementById("dummy-chat-button-iframe")
        : null;

      if (featuresContainerTop < headerBottom) {
        stickyAtc.classList.add("sticky-bar");
        document.querySelector(".td-product-sticky-atc__title").style.display =
          "block";
        document.querySelector(".td-product-payments").style.display = "block";
        document.querySelector(".td-product-sticky-atc.sticky-bar").style.top =
          "calc(100% - " + stickyAtc.offsetHeight + "px)";
        if (speechBubble) {
          speechBubble.style.zIndex = "0";
        }
      } else {
        if (document.querySelector(".td-product-sticky-atc.sticky-bar")) {
          document.querySelector(
            ".td-product-sticky-atc.sticky-bar"
          ).style.top = "100%";
          setTimeout(() => {
            stickyAtc.classList.remove("sticky-bar");
            document.querySelector(
              ".td-product-sticky-atc__title"
            ).style.display = "none";
            document.querySelector(".td-product-payments").style.display =
              "none";
          }, 500);
        }
        if (speechBubble) {
          speechBubble.style.zIndex = "2147483647";
        }
      }
    });
  }

  let customProductContainer = document.querySelector(".custom-product");
  if (
    customProductContainer &&
    document.querySelectorAll(".td-header__logo").length > 0
  ) {
    let headerLogo = document.querySelectorAll(".td-header__logo")[1];
    if (window.innerWidth <= 600) {
      customProductContainer.style.paddingTop = "0";
      headerLogo.style.padding = "0";
    }
  }

  //for zipcode entry field

  //let checkAvailabilityButton = document.querySelector(".td-product-confirm-zipcode__button");

  //if (checkAvailabilityButton) {
  //    checkAvailabilityButton.addEventListener('click', function () {
  //        if (document.querySelector(".td-product-confirm-zipcode__input").value) {
  //            document.querySelector(".td-product-confirm-zipcode__list").style.display = "block";
  //        }
  //    });
  //}

  let notifyMeButton = document.querySelector(".td-product-notify-me__button");
  let notifyMeSubmitButton = document.querySelector(
    ".td-product-confirm-email_notify_me"
  );

  if (notifyMeButton) {
    notifyMeButton.addEventListener("click", function () {
      // When the wishlist button is clicked
      notifyMeButton.textContent = "Enter your email below:";
      notifyMeButton.style.cursor = "default";
      notifyMeButton.style.textDecoration = "none";
      document.querySelector(".td-product-notify_me__wrapper").style.display =
        "block";
    });

    notifyMeButton.addEventListener("mouseover", function () {
      // When the mouse hovers over the wishlist button
      notifyMeButton.style.cursor = "pointer";
      notifyMeButton.style.textDecoration = "underline"; // Example: Underline when hovered
    });

    notifyMeButton.addEventListener("mouseout", function () {
      // When the mouse leaves the wishlist button
      notifyMeButton.style.cursor = "default";
      notifyMeButton.style.textDecoration = "none"; // Remove underline when not hovered
    });

    let isFormSubmitted = false; // Flag to track form submission

    notifyMeSubmitButton.addEventListener("click", function (event) {
      if (isFormSubmitted && grecaptcha.getResponse() == "") {
        document.querySelector(".g-recaptcha").style.display = "block"; // Show the reCAPTCHA
        event.preventDefault(); // Now 'event' is defined
        notifyMeButton.textContent = "Please complete the reCAPTCHA"; // Handle error here
      } else {
        document.querySelector(".g-recaptcha").style.display = "none"; // Don't display reCAPTCHA
        let checkboxElement = document.getElementById("optInEmail");
        let isChecked = checkboxElement.checked; // This line gets the checked state of the checkbox

        let emailInput = document.querySelector(
          ".td-product-confirm-email__input"
        ).value;
        let email = emailInput.trim().toLowerCase();

        if (validateEmail(email)) {
          const currentTime = new Date().toLocaleString();
          
          notifyMeButton.textContent = "Adding to list...";
          fetch("https://sheetdb.io/api/v1/lqone4jw9iwmv", {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },

            body: JSON.stringify({
              data: [
                {
                  Email: email,
                  SKU: meta.product.variants[0].sku,
                  "Product": meta.product,
                  "Product Name": meta.product.variants[0].name,
                  "Product Vendor": meta.product.vendor,
                  "Date/Time": currentTime,
                  "Marketing Opt In": isChecked,
                },
              ],
            }),
          })
            .then((response) => {
              if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
              }
              notifyMeButton.textContent = "Successfully added to list!"; // Update here
              return response.json();
            })
            .then((data) => console.log(data))
            .catch((error) => {
              console.error("Fetch error:", error);
              notifyMeButton.textContent = "Error submitting. Please try again"; // Handle error here
            });

          fetch("https://ayx6r7es6w3emmf6gzledvd5fy0itzhx.lambda-url.us-east-2.on.aws/", {
              method: "POST",
              mode: "cors",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
              },

              body: JSON.stringify({
                data: [
                  {
                    "Email": email,
                    "SKU": meta.product.variants[0].sku,
                    "Product": meta.product,
                    "Product Name": meta.product.variants[0].name,
                    "Product Vendor": meta.product.vendor,
                    "Date/Time": currentTime,
                    "Marketing Opt In": isChecked,
                    "No Search Result": false
                  },
                ],
              }),
            })
              .then((response) => {
                
                if (!response.ok) {
                  throw new Error(`HTTP error! Status: ${response.status}, ... ${response.statusText}`);
                }
                isFormSubmitted = true; // Set the flag to true after the first submission
                // notifyMeMessage.style.color = "var(--body_font_color)";
                // notifyMeMessage.textContent = "Successfully added!!";
                // notifyMeMessage.style.display = "block";
                return response.json();
              })
              .then((data) => console.log(data))
              .catch((error) => {
                console.error("Fetch error:", error);
                notifyMeError.textContent = "Error submitting. Please try again"; // Handle error here
                notifyMeError.style.display = "block";
              });

          document.querySelector(
            ".td-product-notify_me__wrapper"
          ).style.display = "none";
          isFormSubmitted = true; // Set the flag to true after the first submission
        } else {
          notifyMeButton.textContent = "Please enter valid email";
        }
      }
    });
  }

  let productImages = document.querySelectorAll(
    ".product-images > div:first-child img"
  );
  let modal = document.querySelector(".td-custom-modal");
  let modalImages = modal.querySelectorAll("img");

  if (productImages) {
    productImages.forEach(function (image, index) {
      image.addEventListener("click", function () {
        if (modal) {
          modal.style.display = "block";
        }
        if (modalImages.length > 0) {
          modalImages.forEach(function (img, idx) {
            img.style.display = "none";
            if (index == idx) {
              img.classList.remove("lazyload");
              img.style.display = "block";
            }
          });
        }
      });
    });
  }

  if (modal) {
    modal.addEventListener("click", function () {
      this.style.display = "none";
    });
  }

  let badges = document.querySelectorAll('.js-badge')
  let conditionSwatches = ['overstock','pristine','excellent','very-good'].map((condition) => document.querySelector(`[data-handle="${condition}"`))
  conditionSwatches.forEach((swatch) => {
    swatch.addEventListener('click', function(e) {  
      let thisSwatch = e.target
    let value = thisSwatch.value.toLowerCase()
    for (let badge of badges) {
      if (badge.dataset.condition === value) {
        badge.classList.remove('hide')
      } else {
        badge.classList.add('hide')
      }
    }
    })
    
  })
});

const validateEmail = (email) => {
  const emailPattern =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return emailPattern.test(email.toLowerCase());
};
